import * as React from 'react';

import imgSrc from './assets/img.svg';
import * as styles from './styles.css';

import { ArticleHeading2, ArticleParagraph1, Button } from '@cian/ui-kit';

interface IConsultationTrapProps {
  isDesktop?: boolean;
  onCLick: () => void;
}

export const ConsultationTrap: React.FC<IConsultationTrapProps> = ({ isDesktop, onCLick }) => {
  return (
    <div className={styles['container']}>
      <div>
        <div className={styles['title']}>
          <ArticleHeading2>Думаете, что делать с квартирой?</ArticleHeading2>
          <ArticleParagraph1>
            Эксперт Циана бесплатно разберёт вашу ситуацию: поможет сориентироваться в цене, сроках и вариантах действий
          </ArticleParagraph1>
        </div>

        <Button size="M" theme="inverted" onClick={onCLick} fullWidth={!isDesktop}>
          Обсудить с экспертом
        </Button>
      </div>

      <div className={styles['img']}>
        <img src={imgSrc} />
      </div>
    </div>
  );
};
